export default "__VITE_ASSET__DBemEEou__"